import { useEffect } from 'react'

import { STATUS } from 'helpers/spa'

const useSerpUgcViewIntersect = (status, sendEvent) => {
  useEffect(() => {
    // has to check against status instead of listings, otherwise it will initialize before the component is rendered
    if (status !== STATUS.idle) {
      return
    }
    const reviewsRatingSection = document.querySelectorAll('.ReviewsRating')

    if (!reviewsRatingSection.length) {
      return
    }

    const observerCallback = (entries, observer) => {
      const categoryNames = []
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const nodes = entry.target.querySelectorAll('.ReviewsSentimentsSection')
          nodes.forEach(node => categoryNames.push(node.textContent))
          observer.unobserve(entry.target)
          categoryNames.forEach(() => {
            sendEvent({
              engagementComponent: `product-card_category`,
              engagementDestination: 'ugc_impression',
              engagementDetails: 'reviews-sentiment',
              name: 'ugc_impression',
              nonInteraction: true,
            })
            sendEvent({
              engagementComponent: `product-card_category`,
              engagementDestination: 'ugc_impression',
              engagementDetails: 'positive-reviews',
              name: 'ugc_impression',
              nonInteraction: true,
            })
            sendEvent({
              engagementComponent: `product-card_category`,
              engagementDestination: 'ugc_impression',
              engagementDetails: 'rating-breakdown',
              name: 'ugc_impression',
              nonInteraction: true,
            })
            sendEvent({
              engagementComponent: `product-card_category`,
              engagementDestination: 'ugc_impression',
              engagementDetails: 'pros-and-cons-snippets',
              name: 'ugc_impression',
              nonInteraction: true,
            })
          })
        }
      })
    }

    let observer = new IntersectionObserver(observerCallback, { threshold: 0.3 })

    reviewsRatingSection.forEach(item => {
      observer.observe(item)
    })

    return () => observer.disconnect()
  }, [status, sendEvent])
}

export default useSerpUgcViewIntersect
